const serverAddress = process.env.NODE_ENV === 'development' ? 'http://localhost:3002' : 'https://davidchavez.tech';

const messageClientAddress = `${serverAddress}/message-client`;
export {
    messageClientAddress
}